import React from 'react';
import { Gift, Map, AlertOctagon, Settings, Zap, Clock, ClipboardCheck } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    icon: Map,
    title: 'Mapa Mental del Jugador Dominante',
    desc: 'Cómo piensa un pro, cómo decide bajo presión y cómo prioriza en combate.'
  }, {
    icon: AlertOctagon,
    title: 'Errores Mortales que Te Hacen Perder Partidas',
    desc: 'Identificá y eliminá las decisiones que te están sabotando.'
  }, {
    icon: Settings,
    title: 'Guía de Configuración Pro',
    desc: 'Sensibilidad + HUD + ajustes optimizados para máxima ventaja.'
  }, {
    icon: Zap,
    title: 'Sistema Anti Tilt',
    desc: 'Control emocional para no perder partidas por bronca.'
  }, {
    icon: Clock,
    title: 'Rutina de 15 Minutos Antes de Jugar',
    desc: 'Entrá enfocado. Entrá activado.'
  }, {
    icon: ClipboardCheck,
    title: 'Checklist de Partida',
    desc: 'Un sistema profesional para analizar y mejorar cada partida.'
  }];
  return <section className="py-24 bg-gradient-to-b from-slate-900 to-black relative overflow-hidden" data-id="element-1">
      {/* Background fire embers effect placeholder */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10 animate-pulse" data-id="element-2" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-3">
        <div className="text-center mb-16 space-y-4" data-id="element-4">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-900/20 border border-red-500/50 rounded-full text-red-400 font-bold uppercase text-sm mb-4" data-id="element-5">
            <Gift className="w-4 h-4" data-id="element-6" />
            Oferta Limitada
          </div>

          <h2 className="text-4xl md:text-6xl font-black text-white uppercase leading-none" data-id="element-7">
            Hoy te llevás estos <br data-id="element-8" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-orange-500" data-id="element-9">
              Bonos Sin Costo Extra
            </span>
          </h2>

          <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-10">
            Porque dominar no es solo disparar mejor. Es pensar mejor.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-11">
          {bonuses.map((bonus, index) => <div key={index} className="bg-slate-900/80 backdrop-blur-sm p-8 border border-slate-800 hover:border-red-500/50 rounded-xl transition-all duration-300 hover:-translate-y-2 group" data-id="element-12">
              <div className="w-14 h-14 bg-gradient-to-br from-red-600 to-orange-600 rounded-lg flex items-center justify-center mb-6 shadow-lg shadow-red-900/20 group-hover:shadow-red-500/40 transition-shadow" data-id="element-13">
                <bonus.icon className="w-8 h-8 text-white" data-id="element-14" />
              </div>

              <div className="text-xs font-bold text-red-500 uppercase tracking-widest mb-2" data-id="element-15">
                Bonus #{index + 1}
              </div>
              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-red-400 transition-colors" data-id="element-16">
                {bonus.title}
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-17">{bonus.desc}</p>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-18">
          <p className="text-2xl font-bold text-white" data-id="element-19">
            Esto no es un ebook. <br className="md:hidden" data-id="element-20" />
            <span className="text-blue-400" data-id="element-21">
              Es un sistema completo de dominación.
            </span>
          </p>
        </div>
      </div>
    </section>;
}